const deleteEmptyFields = (obj) => {
    const nonEmptyFields = Object.keys(obj).filter((item) => Boolean(obj[item]))
    let newObj = {};

    nonEmptyFields.forEach(field => newObj = { ...newObj, [field]: obj[field] })
    return newObj;
}

export default deleteEmptyFields;